import { Company } from './company';
import { CompanyListItemDto } from './dialog-dto/company-list-item.dto';
import { CustomerListItemDto } from './dialog-dto/customer-list-item.dto';

export interface User {
  role: string;
  token: string;
  company: Company;
  user: UserDto
}

export interface UserDto {
  username: string
  e_mail: string
  firstname: string
  lastname: string
  password: string
  active: boolean
  guid: string
  id: number
}

export interface UserUpper {
  Active: boolean
  ContactID: number
  EMail: string
  Firstname: string
  Lastname: string
  GUID: string
  ID: number
  RoleID: number
  Role?: Role
  Username: string
  Tags: Tag[]
  SeesAll: boolean
  // Display-only, populated client-side (mat-table-user "Scope" column) —
  // not part of the backend's /data/users response.
  Clients?: CompanyListItemDto[]
  Customers?: CustomerListItemDto[]
}

export interface Tag {
  Active: boolean
  Color: string
  Name: string
  ID: number
  GUID: string
  // Display-only, populated client-side (mat-table-tags "Scope" column) — the
  // Clients/Customers this (Sonderfall) tag currently grants access to.
  Clients?: CompanyListItemDto[]
  Customers?: CustomerListItemDto[]
}

// Name of the permanent, protected "Any" tag — the user-facing on/off switch
// for User.SeesAll. Kept as a single constant so frontend code that needs to
// recognize/pin it (dialog-add-user, mat-table-user, settings-tags) stays in
// sync with the backend's reserved name (auth_controller.go `anyTagName`).
export const ANY_TAG_NAME = 'Any';

export interface Role {
  Description: string
  Name: string
  ID: number
  GUID: string
}

export interface SaveUserDto {
  username: string
  firstname: string
  lastname: string
  email: string
  role: number
  active: boolean
  // Primary, direct visibility grants.
  clientIds: number[]
  customerIds: number[]
  seesAll: boolean
  // Admin-only optional special-case grants.
  tags: Tag[]
}


